export default __webpack_public_path__ + "static/media/wallpaperheaven.1ed211a8.png";